<template>
    <div class="modal-card" style="width: auto; min-width: 680px">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ activeCompany?.Name || "New Company" }}</p>
        </header>
        <section class="modal-card-body">
            <o-tabs v-model="activeStep" :has-navigation="false" class="is-flex-wrap-nowrap">
                <o-tab-item :step="1" label="Details" icon="info">
                    <o-field label="Name" v-bind:class="{ closed: acOptionsFiltered?.length == 0 }">
                        <o-autocomplete v-if="activeCompany?.ID == undefined || $store.getters.user.SiteAdmin" v-model="existingCompany" :data="acOptionsFiltered" :debounceTyping="300" field="Text" open-on-focus expanded :clear-on-select="true" @typing="UpdateCompanyName" @select="SelectRow">
                            <template v-slot:empty>No results</template>
                        </o-autocomplete>

                        <!-- <o-input v-model="activeCompany.Name" v-else></o-input> -->
                        <div v-else>{{ activeCompany.Name }}</div>
                    </o-field>
                    <o-field label="City">
                        <o-input v-model="activeCompany.City" autocomplete="off"></o-input>
                    </o-field>
                    <o-field label="Countries">
                        <inputitems v-model="countries" type="country" :maxitems="10"></inputitems>
                    </o-field>
                    <o-field label="Web address">
                        <o-input v-model="activeCompany.WebAddress" autocomplete="off"></o-input>
                    </o-field>
                    <o-field label="Global revenue">
                        <o-select v-model="activeCompany.GlobalRevenue">
                            <option value="Global Revenue">Global Revenue</option>
                            <option value="< $1B">&lt; $1B</option>
                            <option value="$1 - $5B">$1 - $5B</option>
                            <option value="$5B +">$5B +</option>
                        </o-select>
                    </o-field>
                    <o-field label="Is this a Private Equity / Venture Capital portfolio company?">
                        <o-checkbox v-model="activeCompany.isPrivateEquity"></o-checkbox>
                    </o-field>
                    <o-field label="Is this a Family Owned Business?">
                        <o-checkbox v-model="activeCompany.isFamilyOwned"></o-checkbox>
                        <p class="is-size-7 has-text-grey mt-2">A family-owned business is typically defined as a company in which a single family owns a significant share of the business and can influence its strategic direction, often across multiple generations.</p>
                    </o-field>
                </o-tab-item>
                <o-tab-item :step="2" :disabled="activeStep < 2 && !activeCompany.ID" label="Industries" icon="industry">
                    <inputitems v-model="industries" type="industry" :maxitems="15" placeholder="Select an industry"></inputitems>
                </o-tab-item>
                <o-tab-item :step="3" :disabled="activeStep < 3 && !activeCompany.ID" label="Relationship" icon="sitemap">
                    <div>
                        <o-radio v-model="radio" name="relationship" :native-value="1" @update:modelValue="RadioParent">
                            Parent company
                        </o-radio>
                    </div>
                    <div>
                        <o-radio v-model="radio" name="relationship" :native-value="2" @update:modelValue="RadioSubsidiary">
                            Subsidiary
                        </o-radio>
                    </div>
                    <o-field label="Parent" v-if="activeCompany?.Parent?.Name &&
                        activeCompany.ParentID != activeCompany.ID &&
                        radio == 2
                        ">
                        {{ activeCompany.Parent.Name }}
                    </o-field>
                    <o-field :label="activeCompany.ParentID != activeCompany.ID
                        ? 'Change to subsidiary of'
                        : 'Subsidiary of'
                        " v-if="radio == 2">
                        <autocomplete v-model="activeCompany.ParentID" :displayText="activeCompany?.Parent?.Name" type="company" placeholder="Please enter the parent of this company"></autocomplete>
                    </o-field>
                    <div class="mt-5">
                        <o-checkbox v-show="radio == 1" v-model="agreement">I am certain this company is not a subsidiary of any other company, <br />including a PE/VC investment firm.</o-checkbox>
                    </div>
                </o-tab-item>
            </o-tabs>
        </section>
        <footer class="modal-card-foot">
            <div>
                <o-button variant="light" @click="Close">Cancel</o-button>
                <o-button variant="danger" v-if="activeCompany?.removable" @click="Remove">Remove</o-button>
            </div>
            <div>
                <o-button v-if="prevStep" @click="activeStep--">&lt; {{ prevStep }}</o-button>

                <o-button v-if="nextStep" variant="primary" :disabled="!stepValid()" @click="activeStep++">
                    {{ nextStep }} >
                </o-button>
                <o-button variant="primary" :disabled="saving || !(stepValid(1) && stepValid(2) && stepValid(3)) || (!agreement && radio == 1)" :loading="saving" @click="Save" v-else>
                    Save
                </o-button>
            </div>
        </footer>
    </div>
</template>
<script>
import { ref, computed, inject, onBeforeMount, onMounted } from "vue";
import { useRouter } from "vue-router";
import { autocomplete, multiselect } from "@/components/webComponents";
import Inputitems from "../webComponents/inputitems.vue";
export default {
    components: { autocomplete, Inputitems },
    props: {
        company: {
            type: Object,
            default: () => {
                return {};
            }
        },
        step: {
            type: [Number],
            default: 1
        }
    },
    setup(props, context) {
        const $http = inject("$http");
        const moment = inject("$moment");
        const $success = inject("$success");
        const $error = inject("$error");
        const $confirm = inject("$confirm");
        const $store = inject("$store");
        const $router = useRouter();

        const saving = ref(false);
        const agreement = ref(false);
        const activeCompany = ref(JSON.parse(JSON.stringify(props.company)));
        const activeStep = ref(props.step);
        const radio = ref(activeCompany.value.ParentID === activeCompany.value.ID && activeCompany.value.ID > 0 ? 1 : 2);

        const existingCompany = ref(activeCompany.value.Name || "");

        const industries = ref([]);

        const text = ref("");

        const options = ref([]);

        const acOptionsFiltered = computed(() => {
            return options.value.filter((option) =>
                (option.Text || "")
                    .toString()
                    .toUpperCase()
                    .indexOf((text.value || "").toUpperCase() >= 0)
            );
        });

        const LoadAcOptions = () => {
            $http
                .get("/api/v2/company/filter?query=" + existingCompany.value)
                .then((resp) => {
                    options.value = resp.data;
                })
                .catch((err) => {
                    options.value = [];
                });
        };

        if (activeCompany.value.CompanyIndustries) {
            industries.value = activeCompany.value.CompanyIndustries.map((x) => {
                return {
                    Id: x.IndustryID,
                    Text: x.Industry?.Name
                };
            });
        }

        const countries = ref([]);

        if (activeCompany.value?.CompanyCountries) {
            countries.value = activeCompany.value.CompanyCountries?.map((x) => {
                return { Id: x.Country.ID, Text: x.Country.Name };
            });
        }

        const countryFilter = ref([
            {
                Id: "CountryId",
                Text: "Country",
                options: "/api/v2/country/filter"
            }
        ]);

        const steps = {
            1: "Details",
            2: "Industries",
            3: "Relationship"
        };

        const prevStep = computed(() => {
            return steps[activeStep.value - 1];
        });
        const nextStep = computed(() => {
            return steps[activeStep.value + 1];
        });

        const stepValid = (step) => {
            step = step || activeStep.value;

            if (step == 1) {
                if (!activeCompany.value.Name) return false;
                if (!activeCompany.value.City) return false;
                if (countries.value.length == 0) return false;
                if (!activeCompany.value.GlobalRevenue) return false;
            }
            if (step == 2) if (industries.value.length == 0) return false;
            if (step == 3) if (radio.value == "2" && !activeCompany.value.ParentID) return false;

            return true;
        };

        const UpdateCompanyName = (text) => {
            LoadAcOptions();
            activeCompany.value.Name = text;
        };

        const RadioParent = () => {
            activeCompany.value.ParentID = null;
        };

        const RadioSubsidiary = () => {
            if (radio.value == 2) return;
            activeCompany.value.ParentID = null;
        };

        const Close = () => {
            context.emit("close");
        };

        const Save = async () => {
            saving.value = true;

            if (countries.value.length > 0) {
                activeCompany.value.CompanyCountries = countries.value.map((c) => {
                    return {
                        ID: activeCompany.value?.CompanyCountries?.find((cc) => cc.CountryID == c.Id)?.ID || 0,
                        CompanyID: activeCompany.value.ID,
                        CountryID: c.Id
                    };
                });
            }
            if (industries.value.length > 0) {
                activeCompany.value.CompanyIndustries = industries.value.map((x) => {
                    return {
                        ID:
                            activeCompany.value?.CompanyIndustries?.find((ci) => ci.IndustryID == x.Id)?.ID || 0,
                        CompanyID: activeCompany.value.ID,
                        IndustryID: x.Id
                    };
                });
            }

            const response = await SaveCompany(activeCompany.value);
            activeCompany.value = response.data;

            context.emit("saved", { company: activeCompany.value, close: Close });
        };

        const SaveCompany = async (comp) => {
            let qs = "";
            if (!activeCompany.value.ID) {
                qs = "?recache=true";
            }

            let response = undefined;
            saving.value = true;
            try {
                response = await $http.post("/api/v2/company" + qs, comp || activeCompany.value);
                $success("Company saved successfully");
            } catch (err) {
                console.error(err);
            }
            saving.value = false;
            return response;
        };

        const Remove = async () => {
            try {
                await $http.delete("/api/v2/company/remove/" + activeCompany.value.ID);
                $success("Company removed successfully");
                context.emit("close");
            } catch (err) {
                console.error(err);
            }
        };

        const SelectRow = (row) => {
            if (row) {
                //activeCompany.value.ID = row.Id;
                //activeCompany.value.Name = row.Text;
                existingCompany.value = row.Text;

                $router.push({ name: "_companyDetail", params: { Id: row.Id } });
                context.emit("close");
            }
        };

        onMounted(() => {
            LoadAcOptions();
            activeCompany.value.removable = false;

            if ($store.getters.isAdmin && activeCompany.value.ID) {
                $http.get("/api/v2/company/" + activeCompany.value.ID + "/removable").then((resp) => {
                    activeCompany.value.removable = resp.data;
                });
            }
        });

        return {
            saving,
            agreement,
            acOptionsFiltered,
            existingCompany,
            activeCompany,
            activeStep,
            industries,
            radio,
            prevStep,
            nextStep,
            countries,
            countryFilter,
            RadioParent,
            RadioSubsidiary,
            Close,
            Save,
            Remove,
            UpdateCompanyName,
            SelectRow,
            stepValid
        };
    }
};
</script>
<style lang="scss" scoped>
footer.modal-card-foot {
    justify-content: space-between;
}

.modal-card-body {
    min-height: 400px;
}

.closed:deep(.dropdown-item) {
    display: none;
}

.closed:deep(.dropdown-content) {
    display: none;
}
</style>
